import React from "react"
import { navigate } from "gatsby"
import styled from "styled-components"

import useSearch from "../../use-search"
import tokens from "../_tokens"
import { SearchResults, TextInput } from "./"
import Downshift from "downshift"

const StyledSearchContainer = styled.div`
  position: relative;
`

const StyledSearchResultsContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  min-width: ${tokens.size.searchWidth}px;
  max-height: 70vh;
  padding: ${tokens.size.base} 0;
  box-shadow: ${tokens.color.boxShadow} 0px 3px 6px;
  background: ${tokens.color.white};
  overflow: auto;
  border-radius: 4px;
  border: solid 1px ${tokens.color.bgLight};
`

function stateReducer(state, changes) {
  switch (changes.type) {
    case Downshift.stateChangeTypes.changeInput:
      if (!changes.inputValue) {
        // Close the menu if the input is empty.
        return { ...changes, isOpen: false }
      }
      return changes
    default:
      return changes
  }
}

function Search() {
  const [query, setQuery] = React.useState("")
  const results = useSearch(query)
  return (
    <Downshift
      inputValue={query}
      onInputValueChange={inputValue => setQuery(inputValue)}
      // We don't need Downshift to keep track of a selected item because as
      // soon as an item is selected we navigate to a new page.
      // Let's avoid any unexpected states related to the selected item
      // by setting it to always be `null`.
      selectedItem={null}
      onSelect={item => {
        if (item) {
          navigate(item.path)
          setQuery("")
        }
      }}
      itemToString={item => (item ? item.title : "")}
      stateReducer={stateReducer}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        getRootProps,
        isOpen,
        highlightedIndex,
      }) => (
        <StyledSearchContainer {...getRootProps()}>
          <TextInput
            {...getInputProps({
              placeholder: `Search...`,
              width: tokens.size.searchWidth,
            })}
          />
          {isOpen ? (
            <StyledSearchResultsContainer {...getMenuProps()}>
              <SearchResults
                results={results}
                getItemProps={getItemProps}
                highlightedIndex={highlightedIndex}
              />
            </StyledSearchResultsContainer>
          ) : null}
        </StyledSearchContainer>
      )}
    </Downshift>
  )
}

export default Search
